<template>
  <div v-if="emp" class="flex flex-wrap text-white text-right">
    <div class="w-1/3" />
    <div class="w-2/3">
      <img class="w-120 mb-8 ml-auto" src="@/assets/images/bg/worklate-title.svg">
      <p class="pr-4 mb-2 text-3xl font-black">{{emp.honorific}}. {{emp.aka_name}}</p>
      <p v-if="emp.job_title" class="pr-4 text-2xl">{{emp.job_title.name}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['emp'],
}
</script>

<style>

</style>